import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { useAppContext } from '../../context/AppContext.js';
import Grid from '../../components/Grid.js';
import Title from '../../components/Title.js';
import PagingBar from '../../components/PagingBar.js';
import IconBranch from '../../components/icons/IconBranch.js';
import ApiService from '../../services/ApiService.js';
import { getWords } from '../../utils/get-words.js';

const UsersMonitorLeft1 = ReactRouterDOM.withRouter(function ({ branch, setBranch }) {
  const { i18n, setError } = useAppContext();
  const words = getWords(i18n.code);
  const [count, setCount] = React.useState(null);
  const [pageNumber, setPageNumber] = React.useState(1);
  const pageSize = 10;
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    setPageNumber(1);
    loadCount();
  }, []);

  React.useEffect(() => {
    loadRecords();
  }, [pageNumber]);

  const loadCount = async function () {
    try {
      setCount(await ApiService.getCountBranches(null));
    }
    catch (error) {
      setError(error);
      return;
    }
  }
  
  const loadRecords = async function () {
    let records = null;
    try {
      const args = {};
      args.offset = (pageNumber - 1) * pageSize;
      args.limit = pageSize;
      records = await ApiService.getBranches(args);
    }
    catch (error) {
      setError(error);
      return;
    }
    setItems(records.map((record, index) => ({
      key: record.branchId,
      data: [
        record.name,
        record.status,
      ],
      record: record
    })));
    if (records.length > 0) {
      setBranch(records[0]);
    }
  }
  
  const refreshMe = async function () {
    await loadCount();
    await loadRecords();
  }
  
  const handleClickItem = async function (e, item) {
    if (e.ctrlKey || e.altKey) {
      return;
    }
    setBranch(item.record);
  }
  
  return (
    <div>
      <div>
        <div className="pb-1 d-flex align-items-center border-bottom">
          <Title level={1} icon={IconBranch} color="blue" label={words.branches} />
          <div className="flex-grow-1" />
        </div>
        <Grid
          contextualActions={[
          ]}
          fields={[
            {
              icon: IconBranch,
              label: words.name,
              type: 'string',
              bindIndex: 0,
            },
            {
              label: words.status,
              type: 'string',
              translate: true,
              variant: 'framed-text',
              color: function (value) { return value === 'inRevision' ? 'red' : (value === 'confirmed' ? 'yellow' : (value === 'sent' ? 'green' : 'black')); },
              alignment: 'center',
              bindIndex: 1,
            },
          ]}
          onClickItem={handleClickItem}
          selectedKey={branch ? branch.branchId : null}
          items={items}
        />
        {count !== null && count !== undefined ?
          <PagingBar
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            countOfItems={count}
            countOfPages={Math.ceil(count/pageSize)}
          /> :
          null
        }
      </div>
    </div>
  );
})

export default UsersMonitorLeft1;
